import { JSX } from "react";

interface ErrorPageProps {
  traceId?: string;
}

function Forbidden(): JSX.Element {
  return errorPageTemplate("Forbidden", "Access is denied due to insufficient privileges", "fa-lock");
}

function NotFound(): JSX.Element {
  return errorPageTemplate("404 Not Found", "Sorry! That web page no longer practices at this location.", "fa-search");
}

function ServerError(props: ErrorPageProps): JSX.Element {
  return errorPageTemplate("Sorry!", "Something went wrong on our end.", "fa-exclamation-triangle", props.traceId);
}

function Unauthorized(): JSX.Element {
  return errorPageTemplate("Unauthorized", "Access is denied due to invalid credentials", "fa-id-badge");
}

function HomepageError(): JSX.Element {
  return errorPageTemplate("Sorry!", "There was an error applying your filters. They have been removed. Please refresh your page to return to the Home screen.", "fa-exclamation-triangle");
}

function errorPageTemplate(title: string, description: string, mainIcon: string, traceId?: string): JSX.Element {
  return (
    <div className="error-page">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <span className="main-icon"><i className={`fa ${mainIcon}`} /></span>
            <span>
              <p className="error-type">{title}</p>
              <p className="error-description">
                <i className="fa fa-angle-double-right pr5" />{description}
                {!!traceId && <><br />
                  <i className="fa fa-angle-double-right pr5" />For help, please contact <a href="mailto:consulting@questanalytics.com">consulting@questanalytics.com</a>.<br />
                  <i className="fa fa-angle-double-right pr5" />Server-side error tracking ID: {traceId}
                </>}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export {
  HomepageError,
  Forbidden,
  NotFound,
  ServerError,
  Unauthorized,
};
